export default "__VITE_ASSET__CqSqNDol__"